export default {
    // Confirm message
    C001: '登録してもよろしいですか？',
    C002: '変更してよろしいですか？',
    C003: '削除してもよろしいですか？',
    C004: '送信してもよろしいですか？',
    C005: '下書きとして登録します。 よろしいですか？',
    C006: '見積を依頼します。 よろしいですか？',
    C007: '見積依頼と同時にお仕事を依頼します。 よろしいですか？',
    C008: '見積なしでお仕事を依頼します。 よろしいですか？',
    C009: '複製を作成します。よろしいですか？',
    C010: '見積を確認、作業を依頼します。よろしいですか？',
    C011: '見積をキャンセルします。よろしいですか？',
    C012: '見積を送信します。よろしいですか？',
    C013: '見積を作成し、社内承認依頼をお送りします。よろしいですか？',
    C014: '変更を確定します。よろしいですか？',
    C015: 'キャンセルを確定します。よろしいですか？',
    C016: 'お断りしてもよろしいですか？',
    C017: 'キャンセルしてもよろしいですか？',
    C018: '作業キャンセルの申込を行います。よろしいですか？',
    C019: '未読に戻しますか？',
    C020: '新規受注明細を [0]件 追加します。よろしいですか？',
    C021: '受注明細 [0]を削除します。よろしいですか？',
    C022: '見積承認済のデータです。\n変更の際は、再度お見積を作成いたします。\n\n明細を追加いたしますか？',
    C023: '見積承認済のデータです。\n変更の際は、再度お見積を作成いたします。\n\n明細を削除いたしますか？',
    C024: '見積承認済のデータです。\n変更の際は、再度お見積を作成いたします。\n\n明細を変更いたしますか？',
    C025: '申込受諾済のデータです。\n変更の際は、再度変更申込をお願いいたします。\n\n明細を追加いたしますか？',
    C026: '申込受諾済のデータです。\n変更の際は、再度変更申込をお願いいたします。\n\n明細を削除いたしますか？',
    C027: '申込受諾済のデータです。\n\n明細を変更いたしますか？',
    C028: '見積承認済のデータです。\n変更の際は、再度お見積を作成いたします。\n\n申込受諾済のデータです。\n変更の際は、再度変更申込をお願いいたします。\n\n明細を追加いたしますか？',
    C029: '見積承認済のデータです。\n変更の際は、再度お見積を作成いたします。\n\n申込受諾済のデータです。\n変更の際は、再度変更申込をお願いいたします。\n\n明細を削除いたしますか？',
    C030: '見積承認済のデータです。\n申込受諾済のデータです。\n\n明細を変更いたしますか？',
    C031: '会社情報を削除します。\n会社に紐づく発注拠点情報および担当者情報を同様に削除します。\nよろしいですか？',
    C032: '下書きとして保存します。よろしいですか？',
    C033: '見積を依頼します。よろしいですか？',
    C034: '見積と同時に依頼します。よろしいですか？',
    C035: '見積なしで依頼します。よろしいですか？',
    C036: '依頼します。よろしいですか？',
    C037: '集合場所はピン止め位置でよろしいでしょうか？',
    C038: '申込を確定します。よろしいですか？',
    C039: '明細No,●を、見積作成不要にします。よろしいですか？',
    C040: 'メッセージをすべて既読にします。よろしいですか？',
    C041: '異なる依頼ステータスが混在します。よろしいですか？',
    C042: 'シフトを確定します。よろしいですか？',
    C043: '資本金が「[0]」円です。\n変更してよろしいですか？',
    // Common messages
    MSG_NO_DATA: '該当するデータが存在しません。',

    // Success
    S001: '登録しました。',
    S002: '変更しました。',
    S003: '削除しました。',
    S004: '送信しました。',
    S005: '下書きとして登録しました！',
    S006: '見積を依頼しました！',
    S007: '見積依頼と同時に依頼しました！',
    S008: '見積なしで依頼しました！',
    S009: '受注No：[0]で複製を作成しました！\n\n下書きとして一時保存されますので、内容を変更してからご依頼ください。',
    S010: '見積を確認しました。',
    S011: 'キャンセルしました。',
    S012: '見積を送付しました。',
    S013: '見積もり承認を依頼しました。',
    S014: 'お断りしました。',
    S015: '申込を確定しました。',
    S016: '調整中に変更しました。',
    S017: 'キャンセルの申込を行いました。',
    S018: '見積作成不要に変更しました。',
    S019: 'すべて既読にしました。',
    S020: 'シフトを確定しました。',
    S021: 'Excel出力が完了しました。',
    S022: 'Excel出力に失敗しました。',
    // Error message
    E001: '入力必須です。',
    E002: 'メールアドレスのフォーマットが正しくありません。',
    E003: 'パスワードの形式が正しくありません',
    E004: 'ファイルがPDF形式ではありません。',
    E005: '該当データは存在しませんでした。',
    E006: '最低１つは選択してください。',
    E007: 'ファイル名が長すぎるため、アップロードできません。',
    E008: '異なるステータスの依頼があります',
    E009: '登録されていないメールアドレスです。',
    E010: '[0]の形式が正しくありません。',
    E011: '[0]のフォーマットが不正です。',
    E012: '現在より前の日時は入力できません',
    E013: '1年以上後の日時は入力できません。',
    E014: '免許資格作業をご記載ください。',
    E015: '服装のご指定を入力ください。',
    E016: '持ち物をご記載ください。',
    E017: '同一の現場担当者が選択されています。',
    E018: 'エクスポートする項目を選択してください。',
    // api error
    E400: 'エラーが発生しました。もう一度お願いします。',
    E401: 'ログインセッションの有効期限が切れています。\nもう一度ログインしてください。',
    E403: 'この機能にアクセスする権限がありません。',
    E404: 'エラーが発生しました。もう一度お願いします。',
    E422: 'エラーが発生しました。もう一度お願いします。',
    E423: 'エラーが発生しました。もう一度お願いします。',
    E500: 'エラーが発生しました。もう一度お願いします。',
    E999: 'エラーが発生しました。もう一度お願いします。',
    //message remark
    M001: '設計ＤＢに指示されたデータがありません',
    M002: '手配ＤＢに既にデータが存在しますので処理を中止しました',
    M003: '手配ＤＢへの登録処理でエラーになりました（新規）',
    M004: '正常終了',
    //message warning
    W001: '開始時間終了時間は以下の条件すべてを満たす必要があります。 \n 1.最低依頼時間は3時間 \n 2.開始時間で指定出来るのは5分単位 \n 3.終了時間で指定出来るのは開始時間から起算して30分単位',
    W002: '期限切れのパスワードです',
    W003: '作業日の前日18:00以降のキャンセルは、\n 当日キャンセル手数料（100%）が発生します。よろしいですか？',
    W004: '作業日の前日12:00～17:59のキャンセルは、\n 前日キャンセル手数料（80%）が発生します。よろしいですか？',
    W005: '合流時、弊社からのご連絡はできませんので、\n現場担当者様よりスタッフへご連絡ください。\n登録してもよろしいですか？'
};

export const MSG_TITLE = {
    //Confirm
    C001: '確認',
    C002: '確認',
    C003: '確認',
    //Success
    S001: '報告',
    S002: '報告',
    S003: '報告',
    //Error
    E001: 'エラー',
    E400: 'エラー',
    E401: 'エラー',
    E403: 'エラー',
    E404: 'エラー',
    E422: 'エラー',
    E423: 'エラー',
    E500: 'エラー',
    E999: 'エラー',
    //warning
    W001: '警告'
};

export const MSG_TYPE = {
    CONFIRM: 1,
    WARNING: 2,
    SUCCESS: 3,
    ERROR: 4,
    CUSTOM: 5
};

export const MSG_BUTTON = {
    okText: 'はい',
    cancelText: 'いいえ',
    sending: '送信'
};
